import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient";
import { PaginationResponse, ResponseData } from "../types/_public";
import { ICategoryStock, IStock, IStockCategory, IStockStatistics } from "../types/newshub/_stock";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();


const path_stocks = PATH_NEWSHUB_API + '/stocks';

const userApi = {
  stocks(params: any): Promise<AxiosResponse<ResponseData<IStockStatistics[]> & PaginationResponse, any>> {
    const url = `${PATH_NEWSHUB_API}/stock-statistics`
    return api.get(url, params)
  },
  allStocks(params: any = {}): Promise<AxiosResponse<ResponseData<IStock[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/stocks`
    return api.get(url, params)
  },
  categories(params: any = {}): Promise<AxiosResponse<ResponseData<IStockCategory[]> & PaginationResponse, any>> {
    const url = `${PATH_NEWSHUB_API}/categories`
    return api.get(url, { ...params, type: 'stock', })
  },
  searchCategories(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICategoryStock[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/categories`;
    return api.get(url, params);
  },
}
export default userApi
